/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationDtoPage } from '../../models/notification-dto-page';
import { NotificationEventType } from '../../models/notification-event-type';

export interface ListNotifications$Params {
  userIds?: Array<string>;
  projectIds?: Array<string>;
  to?: string | null;
  markedAsRead?: boolean | null;
  logEventTypes?: Array<NotificationEventType>;
  resourceIds?: Array<string>;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'payload' | '-payload' | 'notificationTypes' | '-notificationTypes' | 'user' | '-user' | 'project' | '-project' | 'markedAsRead' | '-markedAsRead' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listNotifications(http: HttpClient, rootUrl: string, params?: ListNotifications$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listNotifications.PATH, 'get');
  if (params) {
    rb.query('userIds', params.userIds, {});
    rb.query('projectIds', params.projectIds, {});
    rb.query('to', params.to, {});
    rb.query('markedAsRead', params.markedAsRead, {});
    rb.query('logEventTypes', params.logEventTypes, {});
    rb.query('resourceIds', params.resourceIds, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationDtoPage>;
    })
  );
}

listNotifications.PATH = '/v0/notifications';
